import PropTypes from 'prop-types';

import Input from '../Input';
import InputMask from '../InputMask';
import InputSelect from '../InputSelect';
import listCountries from '../../utils/Countries';

import { SwitchRow, Track, SwitchLabel } from './styles';

const propTypes = {
  isForeigner: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

/**
 * CPF, ou passaporte com o país emissor.
 *
 * O switch é só visual: não vai no formulário. Quem diz que a pessoa é
 * estrangeira é a ausência de CPF.
 */
const DocumentFields = ({ isForeigner, onToggle }) => (
  <>
    <SwitchRow>
      <Track
        type="button"
        role="switch"
        aria-checked={isForeigner}
        aria-label="Estrangeiro"
        id="foreigner-switch"
        isOn={isForeigner}
        onClick={() => onToggle(!isForeigner)}
      />
      {/* O clique no label já é encaminhado ao botão pelo `htmlFor`; um
          onClick aqui dispararia o toggle duas vezes e anularia a troca. */}
      <SwitchLabel htmlFor="foreigner-switch">Estrangeiro</SwitchLabel>
    </SwitchRow>

    {isForeigner ? (
      <>
        <Input name="passportNumber" label="Passaporte" />
        <InputSelect
          name="passportCountry"
          label="País emissor do passaporte"
          placeholder="Selecione o país"
          noOptionsMessage="Nenhum país encontrado"
          options={listCountries()}
        />
      </>
    ) : (
      <InputMask name="cpf" label="CPF" mask="999.999.999-99" />
    )}
  </>
);

DocumentFields.propTypes = propTypes;

export default DocumentFields;
